import { render } from "./TrainingIndication.vue?vue&type=template&id=4dc4e022&scoped=true&ts=true"
import script from "./TrainingIndication.vue?vue&type=script&lang=ts"
export * from "./TrainingIndication.vue?vue&type=script&lang=ts"

import "./TrainingIndication.vue?vue&type=style&index=0&id=4dc4e022&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc4e022"]])

export default __exports__